import { useState, useEffect, useRef } from "react";
import { Shape, StickyNote, Text } from "../../../typings/miro";
import { duplicateProps } from "../../../refractCommon/miro/duplicateProps";
import { createItem } from "../../../refractCommon/miro/create";
import { removeHtml } from "../../../refractCommon/removeHtml";
const { board } = window.miro;

function split(text: string, splitter: string) {
  return removeHtml(text)
    .split(splitter)
    .filter((t) => t.length > 0);
}

let item: Shape | Text | StickyNote;

export default function Split( ) {
  const [previews, setPreviews] = useState<string[]>([]);
  const [warning, setWarning] = useState("");
  const [splitter, setSplitter] = useState("");
  const [toolOpen, setToolOpen] = useState(false);
  const [setHeight, setHeightState] = useState("0px");

  const content = useRef<HTMLInputElement>(null);

  function handleToggleOpen() {
    setToolOpen(!toolOpen);
    setHeightState(toolOpen ? "0px" : `${content?.current?.scrollHeight}px`);
  }

  const splitItemTypeIcons = (
    <div className="cs5 ce12 grid">
      <div className="m2 icon icon-rectangle cs1"></div>
      <div className="m2 icon icon-sticky-bulk cs2"></div>
      <div className="m2 icon icon-text cs3"></div>
    </div>
  );

  async function getSelection() {
    const miroSelection = await miro.board.getSelection();
    item = miroSelection[0] as any;

    if (splitter.length === 0) {
      setWarning("Please enter a character to split the text by.");
      return;
    }

    if (miroSelection.length === 0) {
      setWarning("Please select an item on the board.");
      return;
    }

    if (miroSelection.length > 1) {
      setWarning("Please select only one item on the board.");
      return;
    }

    if (!["text", "sticky_note", "shape"].includes(item.type)) {
      setWarning("Please select either a text, sticky, or shape item.");
      return;
    }

    const splitted = split(item?.content, splitter);

    if (splitted.length === 1) {
      setWarning(`Splitter ${splitter} not found in item text.`);
      return;
    }

    if (warning !== "") {
      setWarning("");
    }
    //setPreviews(split(item?.content, splitter));
    return splitted;
  }

  function handleSplitter(event: React.ChangeEvent<HTMLInputElement>) {
    setSplitter(event.target.value);
    // setPreviews(split(item?.content, event.target.value));
  }

  async function handleSplit() {
    const previews = await getSelection();
    if (previews) {
      for (const [index, preview] of previews.entries()) {
        const newItem = (await createItem({
          ...duplicateProps(item),
          content: preview,
          x: item.x + item.width * 1.1 * (index + 1),
        })) as any;

        // // Adjust the y position of the text to stay at top of the source item
        // if (item.type === "text" && newItem) {
        //   newItem.y = item.y - item.height / 2 + newItem.height / 2;
        //   await newItem.sync();
        // }
      }
    }
  }

  return (
    <div id="split-text-tool" className="grid tool-section mt-0 pb-0">
      <div
        id="split-text-tool-header"
        className={"grid cs1 ce12 mt-0 cursor-pointer"}
        onClick={(event) => {
          handleToggleOpen();
        }}>
        <div className="cs1 mb-0 icon m2 icon-tile"></div>
        <div className="cs2 ce11 h3 mb-0">Split text</div>
        <div
          className={
            "cs12 icon m2 mb-0 mt-0 cursor-pointer" +
            " " +
            (toolOpen === false ? " icon-arrow-right" : " icon-arrow-down")
          }></div>
      </div>

      <div
        id="accordion-content"
        ref={content}
        style={{ maxHeight: `${setHeight}` }}
        className="cs1 ce12 grid accordion">
        <div id="accordion-margin" className="cs1 ce12 grid mb-8">
          <div className="cs1 ce12 p-medium mt-0">
            Split an item's text into many seperate items, based on a chosen
            delimiter.
          </div>

          <div
            id="split-works-on"
            className="help-container grid cs1 ce12 mt-0 mb-8 pt-8">
            <p className="p-small cs1 ce4 mb-0 mt-0">
              Works on <b> 1:</b>
            </p>
            {splitItemTypeIcons}
          </div>

          <div className="grid cs1 ce12 ">
            <div className="cs1 ce12 form-group mb-0">
              <label className="cs1 ce3">Split on:</label>
              <input
                onChange={handleSplitter}
                className="input input-small mb-0 cs4 ce12"
                type="text"
                placeholder="Enter a character to split the text by"
              />
            </div>

            {warning.length > 0 && (
              <div className="cs1 ce12 label label-warning">{warning}</div>
            )}
            <button
              type="button"
              className="button button-primary button-small cs1 ce12"
              onClick={handleSplit}>
              Split
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
